<div *ngIf="linksList && !!linksList.length" class="interlinks">
    <h2 class="interlinks__title" i18n="@@interlinking_more_hotels">Otros alojamientos a buenos precios</h2>
    <div class="interlinks__links-container">
        <a *ngFor="let link of linksList" target="_blank" href="{{link.url}}" class="interlinks__links-container__link">
            <mb-icon-text>
                <mb-icon icon="hotels"></mb-icon>
                <span>{{link.cityName}}</span>
            </mb-icon-text>
        </a>
    </div>
</div>